import React from 'react';

export const StopwatchIcon = () => (
  <svg
    fill="none"
    stroke="#FFFFFF"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Top button */}
    <rect x="10" y="2" width="4" height="2" rx="1" fill="#FFFFFF" />
    {/* Main circle */}
    <circle cx="12" cy="14" r="8" />
    {/* Center dot */}
    <circle cx="12" cy="14" r="1" fill="#FFFFFF" />
    {/* Clock hand pointing up */}
    <line x1="12" y1="14" x2="12" y2="8" />
  </svg>
);
